"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var YotpoShareReviewButton_1 = require("./YotpoShareReviewButton");
var YotpoWriteReview = function (_a) {
    var productId = _a.productId, shareReviewText = _a.shareReviewText, shareReviewButtonText = _a.shareReviewButtonText;
    return ((0, preact_1.h)("div", { class: 'yotpo-write-review' },
        (0, preact_1.h)("p", { class: 'yotpo-write-review__text' }, shareReviewText),
        (0, preact_1.h)(YotpoShareReviewButton_1.default, { productId: productId, shareReviewButtonText: shareReviewButtonText })));
};
exports.default = YotpoWriteReview;
